export enum Provider {
  AUTHORIZE_NET = 'AUTHORIZE_NET',
}
